import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Text } from 'shared/components/Text/Text';

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    gap: 24px;
  }
`;

export const BodyText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;

export const Label = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const Value = styled(BodyText)`
  color: ${({ theme }) => theme.colors.textSecondarySubtleGrey80};
`;

export const LinkStyled = styled(Link)`
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textSystemInfoSecondary2100};
`;
